import { render, staticRenderFns } from "./GoalsFormDrawer.vue?vue&type=template&id=1295c3f9&scoped=true&"
import script from "./GoalsFormDrawer.vue?vue&type=script&lang=js&"
export * from "./GoalsFormDrawer.vue?vue&type=script&lang=js&"
import style0 from "./GoalsFormDrawer.vue?vue&type=style&index=0&id=1295c3f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1295c3f9",
  null
  
)

export default component.exports